import { getRandomColour } from 'src/utils/random-color-generator'
export class SpeakerColours {
    public static instance: SpeakerColours = new SpeakerColours()
    private speakerMap: { [key: string]: string } = {}

    public getColour(id: string): string {
        // Return existing color or generate if not initialized
        if (!this.speakerMap[id]) {
            this.speakerMap[id] = getRandomColour()
        }

        return this.speakerMap[id]
    }
}
